import { useAtom } from '@reatom/npm-react'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { NumericFormat } from '@root/shared/core/format'
import { BundlerIcon } from '@root/shared/ui-kit'

import { PairStatsPanelItem } from './pair-stats-panel-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelBundlers: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()

  const [bundlers] = useAtom(pair.bundlers)

  const percent = bundlers.holding

  const formatted = useMemo(
    () => NumericFormat.formatPreset(percent, 'percents', { mantissa: 2 }),
    [percent],
  )

  return (
    <PairStatsPanelItem
      title={t('bundlers')}
      intent="Safe"
      icon={BundlerIcon}
      tooltip={t('trading.audit.bundlers.holding-tooltip', {
        percentage: formatted,
      })}
      value={<FlashTextContentDistinct>{formatted}%</FlashTextContentDistinct>}
    />
  )
})
